




















































import { defineComponent, ref, getCurrentInstance, computed, watch } from '@vue/composition-api';
import DebounceTooltip from '@/renderer/components/common/DebounceTooltip.vue';
import searchHandler from '@/renderer/scripts/composition/searchHandler';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import drawerHandler from './composition/drawerHandler';
import Guide from './Guide/index.vue';
import MyFavorite from './MyFavorite/index.vue';
import RecentUse from './RecentUse/index.vue';
export default defineComponent({
  components: {
    Guide,
    MyFavorite,
    RecentUse,
    DebounceTooltip,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const router = vm.$router;
    const store = vm.$store;
    const { query } = router.currentRoute;
    const tabValue = ref(query.tab || 'recentlyUsed');
    const favoriteRef = ref();
    const recentlyUsedRef = ref();
    const isLoading = computed(() => recentlyUsedRef.value?.loadingOnHeader || favoriteRef.value?.loadingOnHeader);
    const hideRefresh = computed(() => recentlyUsedRef.value?.loadingList || favoriteRef.value?.loadingList);
    const showPopup = ref(false);

    // 非移动端样式，和有个人空间的情况下才有新手引导
    const hasGuide = computed(() => {
      const { isMobile, isMobileStyle, hasPersonalSpace, userBaseInfo } = store.getters;
      const { isTemporary, userId } = userBaseInfo;
      if (isMobile || isMobileStyle || isTemporary) return false;
      // 刷新页面时，userId可能为-1，此时不显示新手引导
      if (userId === -1) return false;
      return hasPersonalSpace;
    });
    // 抽屉相关的代码块
    const { methods: drawerHandlerMethods } = drawerHandler();

    const { methods: searchMethods } = searchHandler();
    const methods = {
      tabChange(val: string) {
        tabValue.value = val;
        router.replace({
          query: {
            tab: val,
          },
        });
        drawerHandlerMethods.setWorkbenchDefault();
        store.commit(DrawerEvents.SET_TOTAL, 0);
        reporter.report('menu_pv', {
          menu: val,
        });
      },
      emitChildFun() {
        showPopup.value = false;
        favoriteRef.value.onOperateEventProxy('allFailure');
      },
      refreshChildList() {
        if (tabValue.value === 'myFavorite') {
          favoriteRef.value.silentRefresh();
        } else {
          recentlyUsedRef.value.silentRefresh();
        }
      },
    };
    const handleHotKeyAction = (action: string): boolean => {
      /**
       * 过滤t-dialog弹窗打开的情况
       * TODO: 后续这个可抽离成函数判断
       */
      if (
        [...document.getElementsByClassName('t-dialog__ctx')].filter(e => (e as HTMLElement).style.display !== 'none')
          .length > 0
      ) {
        return false;
      }
      if (action === 'search') {
        searchMethods.openSearch({
          keyword: '',
          scope: 'global',
        });
        return true;
      }
      return false;
    };
    return {
      tabValue,
      hasGuide,
      showPopup,
      // showGuide,
      isLoading,
      hideRefresh,
      favoriteRef,
      recentlyUsedRef,
      handleHotKeyAction,
      ...methods,
    };
  },
});
